export default __webpack_public_path__ + "static/media/cv-border.661d3560.svg";